import React, { useEffect, useState, useRef, Alert } from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link } from 'react-router-dom';
import api from '../../axiosConfig';
import Modal from 'bootstrap/js/dist/modal';
import AsyncSelect from 'react-select/async';
import Select from 'react-select';


export default function TablaAutorizaciones() {
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const [search, setSearch] = useState('');
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [editingUser, setEditingUser] = useState(null);
    const [selectedEmpleado, setSelectedEmpleado] = useState(null);
    const [roles, setRoles] = useState([]);
    //const [selectedRoles, setSelectedRoles] = useState([]);

    const [selectedRoles, setSelectedRoles] = useState([]);
    const [rolesOptions, setRolesOptions] = useState([]);
    const rfcRef = useRef();
    const nombreRef = useRef();
    const curpRef = useRef();
    const [empleadosDefaultOptions, setEmpleadosDefaultOptions] = useState([]);

    const autorizacionRef = useRef();

    function generarAutorizacion() {
        // 6 dígitos (000000–999999). Si no quieres ceros a la izquierda, usa la versión de abajo.
        const code = Math.floor(Math.random() * 1000000).toString().padStart(6, '0');
        if (autorizacionRef.current) {
            autorizacionRef.current.value = code;
        }
    }

    // --------- Prefetch al abrir el menú (click) para mostrar opciones sin teclear ----------
    const prefetchEmpleados = async () => {
        try {
            const opts = await loadEmpleados('');
            setEmpleadosDefaultOptions(opts);
        } catch {
            setEmpleadosDefaultOptions([]);
        }
    };

    const loadEmpleados = async (inputValue) => {
        try {
            const res = await api.get(`/empleados/sinUsuarioSelect2?cadena=${inputValue}&pagina=1`);
            return (res.data?.results || []).map(emp => ({
                label: emp.text,
                value: String(emp.id),
                data: emp
            }));

        } catch (err) {
            console.error("Error al cargar empleados:", err);
            return [];
        }
    };



    useEffect(() => {
        getDatos();
    }, [page, limit, search]);



    const getDatos = async () => {
        try {
            const res = await api.get(
                `/autorizaciones/table?inicio=${(page - 1) * limit}&longitud=${limit}&orden=desc&ordenColumn=id_autorizacion&cadena=${search}`
            );
            setData(res.data.data);
            //setTotal(res.data.recordsTotal);
            setTotal(res.data.recordsFiltered);
        } catch (err) {
            console.error("Error al obtener datos:", err);
        }
    };

    const handleSearchChange = (e) => {
        setSearch(e.target.value);
        setPage(1);
    };

    const handleDelete = async (user) => {
        console.log(user)
        const confirmDelete = window.confirm(`¿Estás seguro que deseas eliminar la autorización "${user.autorizacion}"?`);

        if (confirmDelete) {
            await api.delete(`/autorizaciones/${user.idAutorizacion}`);

            getDatos();
        }

    };

    const handleEdit = (user) => {
        console.log("user", user)
        setEditingUser(user);
        setSelectedEmpleado({
            label: user.idEmpleado.nombre,
            value: user.idEmpleado.idEmpleado,
            data: user.idEmpleado
        });

        const modal = new Modal(document.getElementById('exampleModal'));
        modal.show();
    };

    const totalPages = Math.ceil(total / limit);

    const getValue = (key, fallback = '') => editingUser?.[key] ?? fallback;
    const getEmpleadoValue = (key, fallback = '') => editingUser?.idEmpleado?.[key] ?? fallback;

    const handleSubmit = async (e) => {
        e.preventDefault();
        const payload = {
            autorizacion: e.target.autorizacion.value,
            idEmpleado: {
                idEmpleado: selectedEmpleado?.value
            }
        };

        try {
            if (editingUser) {
                await api.put(`/autorizaciones/${editingUser.idAutorizacion}`, payload);
            } else {
                await api.post(`/autorizaciones`, payload);
            }
            getDatos();
            const modal = Modal.getInstance(document.getElementById('exampleModal'));
            modal.hide();

        } catch (err) {
            console.error("Error al guardar usuario:", err);
        }
    };

    const renderFooter = () => {
        return (
            <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mt-24">
                <span>Mostrando {data.length} de {total} Registros</span>
                <ul className="pagination d-flex flex-wrap align-items-center gap-2 justify-content-center">
                    {/* Botón anterior */}
                    <li className="page-item">
                        <button
                            className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
                            onClick={() => page > 1 && setPage(page - 1)}
                            disabled={page === 1}
                        >
                            <Icon icon="ep:d-arrow-left" />
                        </button>
                    </li>

                    {/* Calcular rango de páginas */}
                    {(() => {
                        const pagesToShow = 5;
                        let startPage = Math.max(1, page - Math.floor(pagesToShow / 2));
                        let endPage = startPage + pagesToShow - 1;

                        if (endPage > totalPages) {
                            endPage = totalPages;
                            startPage = Math.max(1, endPage - pagesToShow + 1);
                        }

                        const pageNumbers = [];
                        for (let i = startPage; i <= endPage; i++) {
                            pageNumbers.push(i);
                        }

                        return pageNumbers.map((num) => (
                            <li className="page-item" key={num}>
                                <button
                                    className={`page-link fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md ${page === num
                                        ? "bg-primary-600 text-white"
                                        : "bg-neutral-200 text-secondary-light"
                                        }`}
                                    onClick={() => setPage(num)}
                                >
                                    {num}
                                </button>
                            </li>
                        ));
                    })()}

                    {/* Botón siguiente */}
                    <li className="page-item">
                        <button
                            className="page-link bg-neutral-200 text-secondary-light fw-semibold radius-8 border-0 d-flex align-items-center justify-content-center h-32-px w-32-px text-md"
                            onClick={() => page < totalPages && setPage(page + 1)}
                            disabled={page === totalPages}
                        >
                            <Icon icon="ep:d-arrow-right" />
                        </button>
                    </li>
                </ul>
            </div>
        )
    }


    return (
        <>
            <div className="card h-100 p-0 radius-12">
                <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                    <div className="d-flex align-items-center flex-wrap gap-3">
                        <span className="text-md fw-medium text-secondary-light mb-0">Mostrar</span>
                        <select
                            className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
                            value={limit}
                            onChange={(e) => setLimit(parseInt(e.target.value))}
                        >
                            <option value={10}>10</option>
                            <option value={20}>20</option>
                            <option value={50}>50</option>
                        </select>
                        <form className="navbar-search">
                            <input
                                type="text"
                                className="bg-neutra h-40-px w-auto"
                                name="search"
                                placeholder="Buscar"
                                value={search}
                                onChange={handleSearchChange}
                            />
                            <Icon icon="ion:search-outline" className="icon" />
                        </form>
                    </div>
                    <button
                        type="button"
                        className="btn btn-primary-600 text-sm btn-sm px-12 py-12 radius-8 d-flex align-items-center gap-2"

                        onClick={() => {
                            setEditingUser(null)
                            const modal = new Modal(document.getElementById('exampleModal'));
                            modal.show();
                        }}
                    >
                        <Icon icon="ic:baseline-plus" className="icon text-xl line-height-1" />
                        Nueva Autorización
                    </button>
                </div>
                <div className="card-body p-24">
                    <div className="table-responsive scroll-sm">
                        <table className="table bordered-table sm-table mb-0">
                            <thead>
                                <tr>
                                    <th scope="col">No. Empleado</th>
                                    <th scope="col">RFC</th>
                                    <th scope="col">Autorización</th>
                                    <th scope="col">Fecha</th>
                                    <th scope="col">Fecha Vigencia</th>
                                    <th scope="col" className="text-center">Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((e) => (
                                    <tr key={e.idAutorizacion}>
                                        <td>{e.idEmpleado?.noEmpleado}</td>
                                        <td>{e.idEmpleado?.rfc}</td>
                                        <td>{e.autorizacion}</td>
                                        <td>{e.fecha}</td>
                                        <td>{e.fechaVigencia}</td>
                                        <td className="text-center">
                                            <div className="d-flex align-items-center gap-10 justify-content-center">
                                                <button
                                                    type="button"
                                                    className="bg-success-focus text-success-600 bg-hover-success-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                    onClick={() => handleEdit(e)}
                                                >
                                                    <Icon icon="lucide:edit" className="menu-icon" />
                                                </button>
                                                <button
                                                    type="button"
                                                    className="bg-danger-focus text-danger-600 bg-hover-danger-200 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                    onClick={() => handleDelete(e)}
                                                >
                                                    <Icon icon="lucide:trash" className="menu-icon" />
                                                </button>

                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    {renderFooter()}
                </div>
            </div>


            {/* Modal */}
            <div className="modal fade" id="exampleModal" tabIndex={-1} aria-hidden="true">
                <div className="modal-dialog modal-lg modal-dialog-centered">
                    <div className="modal-content radius-16 bg-base">
                        <div className="modal-header py-16 px-24 border-bottom">
                            <h5 className="modal-title">
                                {editingUser ? 'Editar Autorización' : 'Nueva Autorización'}
                            </h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" />
                        </div>
                        <div className="modal-body p-24">
                            <form onSubmit={handleSubmit}>
                                <div className="row">

                                    <div className="col-12 mb-20">
                                        <label className="form-label">No. Empleado</label>
                                        <AsyncSelect
                                            required
                                            cacheOptions
                                            defaultOptions={empleadosDefaultOptions}   // se llenan al abrir
                                            onMenuOpen={prefetchEmpleados}             // 🔎 buscar al click
                                            loadOptions={loadEmpleados}
                                            // onChange={setSelectedEmpleado}
                                            onChange={(selected) => {
                                                const empleado = selected?.data?.data;
                                                setSelectedEmpleado(selected); // Solo el ID o número de empleado
                                            }}
                                            placeholder="Buscar empleado..."
                                            value={selectedEmpleado}
                                        />
                                    </div>
                                </div>

                                <div className="row">

                                    <div className="col-6 mb-20">
                                        <label className="form-label">Autorización</label>
                                        <div className="d-flex gap-2">
                                            <input
                                                type="text"
                                                name="autorizacion"
                                                required
                                                className="form-control"
                                                defaultValue={getValue('autorizacion')}
                                                ref={autorizacionRef} />
                                            <button
                                                type="button"
                                                className="btn btn-outline-secondary"
                                                onClick={generarAutorizacion} >
                                                Generar
                                            </button>
                                        </div>
                                    </div>

                                </div>
                                <div className="text-center mt-24">
                                    <button type="submit" className="btn btn-primary px-48 py-12">
                                        Guardar
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}